import React, {useCallback, useEffect, useState} from "react";
import {header} from "../../Components/Url/ApiUrl";
import {Logout} from "../../Components/Actions/Actions";
import swal from "sweetalert";
import EditDocuments from "./EditDocuments";
import ShowFile from "../../Components/ShowFile/ShowFile";
import {useTranslation} from "react-i18next";

const CompanyDocuments = ({user}) => {
    const {t} = useTranslation();
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [showModal, setShowModal] = useState(false);
    const [pdfUrl, setPdfUrl] = useState(null);
    const [showFile, setShowFile] = useState(false);

    const handleViewFile = async (filename) => {
        try {
            const response = await fetch(process.env.REACT_APP_API_ENDPOINT+'/files/document/'+filename, {
                method: "GET",
                headers: header
            });

            if (!response.ok) {
                alert(`${t('cannot_upload_file')}. ${t('translation:token_expired')}`);
                window.location.reload();
                return;
            }

            const blob = await response.blob();
            if (blob.type !== "application/pdf") {
                alert(t('translation:pdf_only'));
                return;
            }
            const fileURL = URL.createObjectURL(blob);
            setPdfUrl(fileURL);
            setShowFile(true);
            // window.open(fileURL, "_blank");
        } catch (error) {
            alert(`${t('error')}: ` + error.message);
        }
    };

    const handleFetch = useCallback(async () => {
        setLoading(true);
        try {
            const response = await fetch(`${process.env.REACT_APP_API_ENDPOINT}/company/company-documents`, {
                method: "GET",
                headers: header,
            });
            if (response.status === 401) {
                Logout();
                return;
            }
            if (!response.ok) {
                throw new Error(t('translation:no_data_found'));
            }
            const companyData = await response.json();
            setData(companyData);

        } catch (error) {
            console.error('Company fetch xatosi:', error);
            swal(t('error'), error.message || t('translation:unknown_error'), "error");
        } finally {
            setLoading(false);
        }
    }, [t]);

    useEffect(() => {
        handleFetch();
    }, [handleFetch]);

    if (loading) {
        return <div className="loading-spinner">{t('translation:loading')}</div>;
    }

    if (!data) {
        return <div>{t('translation:error_occured')}</div>;
    }
    const toggleEditMode = () => {
        setShowModal(true);
    };
    const handleCancel = () => {
        setShowModal(false);
    }
    return (
        <div className="company-view">
            <div className="d-flex pb-3">
                <h3 className="m-0 me-2">{t('company_documents')}</h3>
                {Boolean(user.can_update) && (
                    <button
                        className="btn btn-rounded btn-outline-primary p-0"
                        style={{width: "32px", height: "32px"}}
                        onClick={toggleEditMode}
                    >
                        <i className="bi bi-pencil-fill"></i>
                    </button>
                )}
            </div>
            {
                user.can_update ?
                    <EditDocuments
                        show={showModal}
                        handleClose={handleCancel}
                        onSuccess={handleFetch}
                        data={data}
                        handleViewFile={handleViewFile}
                        user={user}
                    />
                    : ''
            }
            {showFile && (
                <ShowFile
                    pdfUrl = {pdfUrl}
                    setShowFile={setShowFile}
                />
            )}
            <table id="w0" className="table table-striped table-bordered detail-view">
                <tbody>
                <tr>
                    <th style={{width: "50%"}}>{t('registered_cerificate')}</th>
                    <td>
                        {data.guvohnoma ? (
                            <button className="btn btn-link p-0"
                                    onClick={() => handleViewFile(data.guvohnoma)}>
                                {t('translation:certificate')} <i className="bi bi-file-pdf"></i>
                            </button>
                        ) : (
                            t('translation:file_not_uploaded')
                        )}
                    </td>
                </tr>
                <tr>
                    <th>{t('comparative_tax_certificate')}</th>
                    <td>
                        {data.soliq_dalolatnoma ? (
                            <button className="btn btn-link p-0"
                                    onClick={() => handleViewFile(data.soliq_dalolatnoma)}>
                                {t('tax_certificate')} <i className="bi bi-file-pdf"></i>
                            </button>
                        ) : (
                            t('translation:file_not_uploaded')
                        )}
                    </td>
                </tr>
                <tr>
                    <th>{t('cooperation_with_education_long')}	</th>
                    <td>
                        {data.oliy_talim_shartnoma ? (
                            <button className="btn btn-link p-0"
                                    onClick={() => handleViewFile(data.oliy_talim_shartnoma)}>
                                {t('cooperation_agreement')} <i className="bi bi-file-pdf"></i>
                            </button>
                        ) : (
                            t('translation:file_not_uploaded')
                        )}
                    </td>
                </tr>
                <tr>
                    <th>{t('scientists_long')}	</th>
                    <td>
                        {data.ilmiy_hodimlar ? (
                            <button className="btn btn-link p-0"
                                    onClick={() => handleViewFile(data.ilmiy_hodimlar)}>
                                {t('scientists_short')} <i className="bi bi-file-pdf"></i>
                            </button>
                        ) : (
                            t('translation:file_not_uploaded')
                        )}
                    </td>
                </tr>
                {
                    user.production ?
                        <tr>
                            <th>{t('local_production_certificate')}</th>
                            <td>
                                {data.ishlab_chiqarish_sertifikat ? (
                                    <button className="btn btn-link p-0"
                                            onClick={() => handleViewFile(data.ishlab_chiqarish_sertifikat)}>
                                        {t('local_production_certificate')}<i className="bi bi-file-pdf"></i>
                                    </button>
                                ) : (
                                    t('translation:file_not_uploaded')
                                )}
                            </td>
                        </tr>
                        :
                        <tr>
                            <th>{t('official_dillership_certificate')}</th>
                            <td>
                                {data.ishlab_chiqarish_sertifikat ? (
                                    <button className="btn btn-link p-0"
                                            onClick={() => handleViewFile(data.ishlab_chiqarish_sertifikat)}>
                                        {t('dillership_certificate')}<i className="bi bi-file-pdf"></i>
                                    </button>
                                ) : (
                                    t('translation:file_not_uploaded')
                                )}
                            </td>
                        </tr>
                }


                </tbody>
            </table>
        </div>
    )
}
export default CompanyDocuments;